
import React from 'react';
import FunnelManagePage from '../features/settings/funnel/FunnelManagePage';

const FunnelManagePageWrapper: React.FC = () => {
    return <FunnelManagePage />;
};

export default FunnelManagePageWrapper;
